import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

export default function ContactSection() {
    const [formState, setFormState] = useState({
        name: "",
        mobile: "",
        email: "",
        email: "",
        message: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);

    const closeModal = () => setShowModal(false);

    const handleChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // TODO: Replace with your actual Google Apps Script Web App URL
        const scriptURL = "https://script.google.com/macros/s/AKfycbwOCHfxGfqPf9vaYVQYjZjRGBAbll848lNIbCkTsKSXe4G9dwOtDLb9vTk-GpkSU6lxBw/exec";

        fetch(scriptURL, {
            method: 'POST',
            body: JSON.stringify(formState),
            // Using 'no-cors' mode might be necessary if the script doesn't handle CORS OPTION requests correctly,
            // but it prevents reading the response. For now, we try standard request.
            // If you face CORS errors, you might need to adjust the script or use 'no-cors'.
        })
            .then(response => {
                // If the script returns success
                setShowModal(true); // Show Custom Modal
                setFormState({
                    name: "",
                    mobile: "",
                    email: "",
                    message: ""
                });
                setIsSubmitting(false);
            })
            .catch(error => {
                console.error('Error!', error.message);
                alert("Something went wrong. Please check your connection or try again later.");
                setIsSubmitting(false);
            });
    };

    return (
        <section className="cnt-section" id="contact">
            {/* Background Decor */}
            <div className="cnt-bg-decor">
                <svg className="cnt-structure struct-1" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
                    <circle cx="50" cy="50" r="45" />
                    <circle cx="50" cy="50" r="30" strokeDasharray="5 5" />
                </svg>
                <svg className="cnt-structure struct-2" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
                    <rect x="20" y="20" width="60" height="60" transform="rotate(45 50 50)" />
                </svg>
                <svg className="cnt-structure struct-3" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
                    <path d="M50 10 L90 90 L10 90 Z" />
                </svg>
                {/* New Structures */}
                <svg className="cnt-structure struct-4" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
                    <path d="M10 50 Q 25 25 50 50 T 90 50" />
                </svg>
                <svg className="cnt-structure struct-5" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
                    <path d="M20 20 L30 20 M25 15 L25 25" /> {/* Plus 1 */}
                    <path d="M70 70 L80 70 M75 65 L75 75" /> {/* Plus 2 */}
                    <path d="M80 20 L90 20 M85 15 L85 25" /> {/* Plus 3 */}
                </svg>
                <svg className="cnt-structure struct-6" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1">
                    <path d="M50 0 L93 25 L93 75 L50 100 L7 75 L7 25 Z" />
                </svg>
            </div>

            <div className="cnt-container">

                {/* --- Left Column: Form & WhatsApp --- */}
                <div className="cnt-form-col">
                    <div className="cnt-header">
                        <span className="cnt-tag">CONTACT US</span>
                        <h2 className="cnt-title">Let's Craft Your Story</h2>
                        <p className="cnt-desc">
                            Have a custom idea or a question? Fill out the form below to get 10% Discount Coupon.
                        </p>
                    </div>

                    <form className="cnt-form" onSubmit={handleSubmit}>
                        <div className="cnt-input-group">
                            <input
                                type="text"
                                name="name"
                                id="name"
                                className="cnt-input"
                                placeholder=" "
                                value={formState.name}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor="name" className="cnt-label">Your Name</label>
                        </div>

                        <div className="cnt-input-group">
                            <input
                                type="tel"
                                name="mobile"
                                id="mobile"
                                className="cnt-input"
                                placeholder=" "
                                value={formState.mobile}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor="mobile" className="cnt-label">Mobile Number</label>
                        </div>

                        <div className="cnt-input-group">
                            <input
                                type="email"
                                name="email"
                                id="email"
                                className="cnt-input"
                                placeholder=" "
                                value={formState.email}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor="email" className="cnt-label">Email Address</label>
                        </div>

                        <div className="cnt-input-group">
                            <textarea
                                name="message"
                                id="message"
                                className="cnt-input cnt-textarea"
                                placeholder=" "
                                value={formState.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                            <label htmlFor="message" className="cnt-label">Tell us about your idea...</label>
                        </div>

                        <button type="submit" className="cnt-submit-btn" disabled={isSubmitting}>
                            {isSubmitting ? "Sending..." : <>Send Message <span className="arrow">→</span></>}
                        </button>
                    </form>

                    {/* Divider */}
                    <div className="cnt-divider">
                        <span className="line"></span>
                        <span className="text">OR</span>
                        <span className="line"></span>
                    </div>

                    {/* Big WhatsApp Block */}
                    <a
                        href="https://wa.me/918897388513"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cnt-whatsapp-box"
                    >
                        <div className="cnt-wa-icon">
                            <i className="fab fa-whatsapp"></i>
                        </div>
                        <div className="cnt-wa-text">
                            <span className="cnt-wa-title">Chat on WhatsApp</span>
                            <span className="cnt-wa-sub">Order/Customize your Product</span>
                        </div>
                        <div className="cnt-wa-arrow">→</div>
                    </a>

                </div>

                {/* --- Right Column: Visual --- */}
                <div className="cnt-visual-col">
                    <div className="cnt-image-wrapper">
                        <img
                            src="images/contactban.webp"
                            alt="Hand holding embroidery thread"
                            className="cnt-image"
                        />
                    </div>

                    {/* Contact Details & Socials (Added below image) */}
                    <div className="cnt-info-box">

                        <div className="cnt-contact-row">
                            <div className="cnt-icon-circle"><i className="fas fa-phone-alt"></i></div>
                            <div className="cnt-contact-text">
                                <span className="cnt-label-sm">Call Us</span>
                                <span className="cnt-value">+91 8897388513</span>
                            </div>
                        </div>

                        <div className="cnt-contact-row">
                            <div className="cnt-icon-circle"><i className="fas fa-map-marker-alt"></i></div>
                            <div className="cnt-contact-text">
                                <span className="cnt-label-sm">Visit Us</span>
                                <span className="cnt-value">Dr.No. 3d-11-4, Western Street,<br />West Godavari District, Eluru, Andhra Pradesh - 534001</span>
                            </div>
                        </div>

                        <div className="cnt-social-row">
                            <a href="https://www.facebook.com/profile.php?id=61585302155060" target="_blank" rel="noopener noreferrer" className="cnt-social-link"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://www.instagram.com/bandham.in" target="_blank" rel="noopener noreferrer" className="cnt-social-link"><i className="fab fa-instagram"></i></a>
                        </div>

                    </div>
                </div>

            </div>

            {/* Custom Modal for Coupon */}
            {
                showModal && ReactDOM.createPortal(
                    <div className="cnt-modal-overlay">
                        <div className="cnt-modal-content">
                            <button className="cnt-modal-close" onClick={closeModal}>×</button>
                            <div className="cnt-modal-header">
                                <i className="fas fa-gift cnt-modal-icon"></i>
                                <h3>Thank you!</h3>
                                <p>You have Unlocked a Discount Coupon</p>
                            </div>
                            <div className="cnt-coupon-box">
                                <span className="cnt-coupon-code">BANDHAM10</span>
                                <span className="cnt-coupon-copy" onClick={() => {
                                    navigator.clipboard.writeText("BANDHAM10");
                                    setCopySuccess(true);
                                    setTimeout(() => setCopySuccess(false), 2000);
                                }} style={{ cursor: 'pointer', marginLeft: '10px', fontSize: '14px' }}>
                                    {copySuccess ? <span style={{ color: '#28a745' }}>Copied!</span> : <i className="far fa-copy"></i>}
                                </span>
                            </div>
                            <p className="cnt-coupon-desc">Use your Coupon Code and Order Now</p>
                            <div className="cnt-modal-footer">
                                <button className="cnt-modal-btn" onClick={closeModal}>Okay, Great!</button>
                            </div>
                        </div>
                    </div>,
                    document.body
                )
            }
        </section >
    );
}